import { useEffect } from "react";
import { matchPath, Outlet, useLocation } from "react-router-dom";
import useCmsStore from "../../store/cmsStore";
import Header from "../Header";
import Footer from "../Footer/Footer";
import styles from "./HomeLayout.module.scss";

const OtherLayout = () => {
  const {
    routeList,
    fetchRouteList,
    addHeroHeaderDetails,
    heroHeaderSectionData,
    addSubpageTitle,
  } = useCmsStore();
  const location = useLocation();
  const headerRouteItems = routeList?.HeroHeaderSection ?? [];
  const { Path } = heroHeaderSectionData || {};

  useEffect(() => {
    const currentRoute = headerRouteItems?.find((route: any) =>
      matchPath({ path: route.Path, end: true }, location.pathname),
    );

    if (currentRoute && currentRoute?.Path !== "/policies/:slug") {
      addSubpageTitle(currentRoute?.Heading);
    }

    if (currentRoute && currentRoute?.Heading !== Path) {
      addHeroHeaderDetails(currentRoute);
    }
  }, [location?.pathname, headerRouteItems]);

  useEffect(() => {
    fetchRouteList();
  }, [location?.pathname]);

  return (
    <div id="page-wrapper" className={styles.pageWrapper}>
      <div className={styles.headerContainer}>
        <Header />
      </div>
      <div className={styles.outletContainer}>
        <Outlet />
      </div>
      <div className={styles.footerContainer}>
        <Footer />
      </div>
    </div>
  );
};

export default OtherLayout;
